var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "row my-4" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "my-4" }, [
          _vm._v("\n        " + _vm._s(_vm.text) + "\n      ")
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.isConnected ? _c("div", { staticClass: "row" }, [_vm._m(0)]) : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c(
        "a",
        {
          staticClass: "btn btn-success btn-lg",
          attrs: { href: "https://line.me/R/ti/p/%40beneatpro" }
        },
        [
          _c("i", { staticClass: "fab fa-line fa-lg" }),
          _vm._v(" ติดต่อเจ้าหน้าที่\n      ")
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9c7b2b4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9c7b2b4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/LineProviderLoginCallback.vue
// module id = 1652
// module chunks = 0